import React, {Fragment, useEffect, useState} from 'react';
import {eliminarPlantilla, mostrarPlantillas} from '../../redux/reducers/plantillasReducers';
import AppBar from "../../components/appBar";

import {IconButton, List, ListItemButton, ListItemSecondaryAction, ListItemText, Typography,} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import PlusFab from "../../components/PlusFab";
import {Close, Help} from "@mui/icons-material";
import LoadingProgress from "../../components/LoadingProgress";
import {Link, useLocation, useNavigate} from "react-router-dom";
import ConfirmDialog from "../../components/ConfirmDialog";
import {MostrarError} from "../../components/MostrarError";
import Strings from "../../assets/strings";
import {hasPermissionTo, PERSMISOS, translateText} from "../../helpers";
import {ButtonResponsive, Empty, ListViewMode, SeacrhAppBar} from "../../components";
import {ReactComponent as EmptySvg} from "../../assets/img/empty.svg";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";

const useStyles = makeStyles(() => ({
    root:{
        padding: 20,

    }
}));
const initialFilter={
    name: '',
    tipo:"",
    mostrarDelSistema:true
};

export default function Plantillas() {
    const classes = useStyles();
    const navigate = useNavigate();
    const location = useLocation();
    const {state:urlState} = useLocation();
    const [filter, setFilter] = useState(initialFilter);


    const Dispatch = useAppDispatch();
    const {list,status,error} = useAppSelector(state => state.plantillas)


    const handleFilter = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {type, value,name,checked} = e.target
        setFilter({...filter,[name]: type === "checkbox" ?checked:value})
    };
    useEffect(() => {
        Dispatch(mostrarPlantillas(filter));
    },[Dispatch,filter])


    const isEmpty = (status !== "loading") && !list?.length;

    const ListItems = () => (
        [true,false]?.map((registroDelSistema,index) => {
            let found = list?.filter(p => p.registroDelSistema === registroDelSistema);
            if (found?.length) {
                return (
                    <List subheader={<Typography color={"secondary"} pl={1}>{registroDelSistema?translateText("registroDelSistema"):translateText("mis")+" "+translateText("plantillas")}</Typography>} key={index}>
                        {found.map(item =>
                            <ListItemButton key={item.id}
                                            sx={item.porDefecto ? {border: "1px solid #dadada"}:{}}
                                      onClick={() => {
                                          if (!hasPermissionTo(PERSMISOS.plantillasActualizar)) return false;
                                          navigate("/editar/plantilla/" + item.id)
                                      }}>
                                <ListItemText primary={item.nombre}
                                              secondary={
                                                  item.descripcion?.replace(/(<([^>]+)>)/gi, "")
                                                      .replaceAll("&nbsp;", "")
                                                      .substring(0, 150).concat('...')+" "+(item.porDefecto ? "(Por defecto)":"")
                                              }
                                />
                                {hasPermissionTo(PERSMISOS.plantillasEliminar) && !item.registroDelSistema &&
                                <ListItemSecondaryAction>
                                    <IconButton
                                        edge="end"
                                        aria-label="comments"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(location.pathname, {state: {confirmDialog: item.id}})
                                        }}
                                        size="large">
                                        <Close className="text-red" fontSize={"small"}/>
                                    </IconButton>
                                </ListItemSecondaryAction>
                                }
                            </ListItemButton>
                        )}
                    </List>
                );
            }else{return <Fragment key={index}></Fragment>}
        })
    )


    return (
          <>
              <AppBar />


              <section className={"contentInner"} style={!isEmpty ? {maxWidth:600, margin:"0 auto"}:{}}>
                  {!urlState && <MostrarError errors={error}/>}
                  {status === "loading"  &&  <LoadingProgress vh/>}

                  <ListViewMode pageRows={list?.length} pageTotalRows={list?.length} noView>
                      <SeacrhAppBar name="name" value={filter.name} onChange={handleFilter} />
                      <ButtonResponsive icon={<Help/>} text={Strings.ayuda} onClick={() => window.open("https://youtu.be/VWifzmEzhRE","_blank")}/>
                  </ListViewMode>
                  <br/>
                  {!isEmpty && <>{ListItems()}</>}


                  {isEmpty &&
                    <Empty Img={EmptySvg} title={Strings.noSeEncontraron+" "+Strings.plantillas}/>
                   }


                  {hasPermissionTo(PERSMISOS.plantillasCrear) &&
                      <PlusFab component={Link} to={"/crear/plantilla"} />
                  }


                  <ConfirmDialog onConfirm={()=>Dispatch(eliminarPlantilla(urlState && urlState.confirmDialog))}/>

              </section>
          </>
        );

}
